import { gql } from '@apollo/client';

export default gql`
    query countTreeEntitiesQuery {
        count: count(dataType: "treetemplate")
    }
`;
